import React, { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { CopyIcon, MoveIcon, TrashIcon } from "~/assets/svg/InterfaceIcon";
import Form from "~/common/components/Form";
import Input from "~/common/components/Input";
import Select from "~/common/components/Select";
import { AppContext } from "../../RoundRegContext";
import { optionList } from "../util/optionData";
import InquiryAddress from "./cardType/InquiryAddress";
import InquiryAgree from "./cardType/InquiryAgree";
import InquiryAlternative from "./cardType/InquiryAlternative";
import InquiryChoice from "./cardType/InquiryChoice";
import InquiryDate from "./cardType/InquiryDate";
import InquiryFile from "./cardType/InquiryFile";
import InquiryLink from "./cardType/InquiryLink";
import InquiryLong from "./cardType/InquiryLong";
import InquiryShort from "./cardType/InquiryShort";
import InquiryTag from "./cardType/InquiryTag";
import InquiryText from "./cardType/InquiryText";
import InquirySelect from "./cardType/InquirySelect";

import { useTranslation } from "react-i18next";
import InquiryCategory from "~/pages/round/RoundReg/Inquiry/content/cardType/InquiryCategory";

const InquiryCase = ({ card, idx }) => {
	const { type } = card;

	switch (type) {
		case "CATEGORY":
			return <InquiryCategory card={card} idx={idx} />;
		case "SHORT":
			return <InquiryShort card={card} idx={idx} />;
		case "LONG":
			return <InquiryLong card={card} idx={idx} />;
		case "CHOICE":
			return <InquiryChoice card={card} idx={idx} />;
		case "ALTERNATIVE":
			return <InquiryAlternative card={card} idx={idx} />;
		case "AGREE":
			return <InquiryAgree card={card} idx={idx} />;
		case "TEXT":
			return <InquiryText card={card} idx={idx} />;
		case "FILE":
			return <InquiryFile card={card} idx={idx} />;
		case "LINK":
			return <InquiryLink card={card} idx={idx} />;
		case "ADDRESS":
			return <InquiryAddress card={card} idx={idx} />;
		case "TAG":
			return <InquiryTag card={card} idx={idx} />;
		case "DATE":
			return <InquiryDate card={card} idx={idx} />;
		case "SELECT":
			return <InquirySelect card={card} idx={idx} />;
		case "MULTISELECT":
			return <InquirySelect card={card} idx={idx} isFields={card.content === "fields"} />;
		default:
			return <InquiryShort card={card} idx={idx} />;
	}
};

const InquiryCardContent = ({ card, connectDragSource, idx }) => {
	const { t } = useTranslation();
	const inquiryForm = useForm({
		defaultValues: {
			inquiryCategory: card.title,
		},
	});

	const { setListByTarget, handleInquiryCopyFields, handleInquiryDelete, changeRequired } =
		useContext(AppContext);
	const elementRef = useRef(null);

	connectDragSource(elementRef);

	const [selectResult, setSelectResult] = useState("SHORT");

	const selectResult22 = inquiryForm.watch("selectCardType") || "SHORT";

	useEffect(() => {
		setSelectResult(selectResult22);
	}, [selectResult22]);

	useEffect(() => {
		let target = {};
		if (card.type === "CATEGORY") {
			target = {
				...card,
				required: false
			};
		} else {
			switch (selectResult) {
				case "TEXT":
					target = {
						...card,
						type: selectResult,
						color: !card.color ? "red" : card.color,
					};
					break;
				case "CHOICE":
					target = {
						...card,
						type: selectResult,
						selectOption: !card.selectOption ? [] : card.selectOption,
					};
					break;
				case "ALTERNATIVE":
					target = {
						...card,
						type: selectResult,
						selectOption: [
							!card.selectOption[0]?.title ? { title: "" } : card.selectOption[0],
							!card.selectOption[1]?.title ? { title: "" } : card.selectOption[1],
						],
					};
					break;
				case "SELECT":
				case "MULTISELECT":
					if (
						card.selectOption?.length > 0 &&
						card.selectOption[0].hasOwnProperty("title")
					)
						card.selectOption = [];

					target = {
						...card,
						type: selectResult,
						selectOption: !card.selectOption ? [] : card.selectOption,
					};
					break;
				default:
					target = { ...card, type: selectResult };
			}
		}
		setListByTarget(target);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectResult]);

	const categoryInput = inquiryForm.watch("inquiryCategory");

	useEffect(() => {
		setListByTarget({ ...card, title: categoryInput });
		// setListByTarget({ ...card, title: categoryInput, required: true });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [categoryInput]);


	return card.type === "" ? (
		<>
			{/*<button ref={elementRef} type="button" className="btn-dynamic-move">*/}
			{/*	<MoveIcon />*/}
			{/*</button>*/}
			{/*<div style={{color: "white"}}>INFO {card.type} {card.title}</div>*/}
			{/*<Form useForm={inquiryForm}>*/}
			{/*	<Input*/}
			{/*		name="inquiryCategory"*/}
			{/*		placeholder={t(*/}
			{/*			"pages.round.RoundReg.Inquiry.content.InquiryCardContent.placeholder"*/}
			{/*		)}*/}
			{/*		value={card.title}*/}
			{/*		required*/}
			{/*	/>*/}
			{/*</Form>*/}
			{/*<div className="dynamic-setting-bottom">*/}
			{/*	<button*/}
			{/*		type="button"*/}
			{/*		className="btn-copy"*/}
			{/*		onClick={() => handleInquiryCopyFields(card.order)}*/}
			{/*	>*/}
			{/*		<CopyIcon />*/}
			{/*	</button>*/}
			{/*	<button*/}
			{/*		type="button"*/}
			{/*		className="btn-trash"*/}
			{/*		onClick={() => handleInquiryDelete(card.order)}*/}
			{/*	>*/}
			{/*		<TrashIcon />*/}
			{/*	</button>*/}
			{/*</div>*/}
		</>
	) : (
		<>
			<button ref={elementRef} className="btn-dynamic-move">
				<MoveIcon />
			</button>
			<InquiryCase card={card} idx={idx} />
			<div className={`dynamic-setting ${card.type === "CATEGORY" ? "w100": ""}`}>
				{
					(card.type !== "CATEGORY") &&
					<Form useForm={inquiryForm}>
						<Select
							name="selectCardType"
							options={optionList}
							defaultValue={card.type}
							value={card.type || ""}
						/>
					</Form>
				}
				<div className={`dynamic-setting-bottom`}>
					{
						(card?.isCompanyData) ?
							<span className="text">
								{t("pages.round.RoundReg.Inquiry.content.InquiryCardContent.required")}
							</span> :
							<>
								{
									(card?.defaultDataType) ?
										<>
											<label className="switch">
												<input
													type="checkbox"
													checked={card.required}
													value={card.required}
													onChange={(e) => changeRequired(e, card.order)}
												/>
												<span className="slider round" />
												<span className="slider-label">
													{t("pages.round.RoundReg.Inquiry.content.InquiryCardContent.required")}
												</span>
											</label>
										</> :
										<>
											<button
												type="button"
												className="btn-copy"
												onClick={() => handleInquiryCopyFields(card.order)}
											>
												<CopyIcon />
											</button>
											<button
												type="button"
												className="btn-trash"
												onClick={() => handleInquiryDelete(card.order)}
											>
												<TrashIcon />
											</button>
											{
												(card.type !== "CATEGORY") &&
												<>
													<div className="divider" />
													<label className="switch">
														<input
															type="checkbox"
															checked={card.required}
															value={card.required}
															onChange={(e) => changeRequired(e, card.order)}
														/>
														<span className="slider round" />
														<span className="slider-label">
															{t("pages.round.RoundReg.Inquiry.content.InquiryCardContent.required")}
														</span>
													</label>
												</>
											}
										</>
								}

							</>
					}
				</div>
			</div>
		</>
	);
};

export default InquiryCardContent;
